console.log("Landing loaded 112233");

var stepBtnArea = document.querySelector(".stepBtns");
var stepBtns = document.querySelectorAll(".stepBtns span");
var stepImgArea = document.querySelector(".stepImgWrapper");
var stepImgs = document.querySelectorAll(".stepImg");
var stepImgAreaWidth = stepImgArea.offsetWidth;

var stepDescs = document.querySelectorAll(".stepDescWrap span");

stepBtnArea.addEventListener("click", chancgeCurrentStep);
console.log(stepBtns);
function chancgeCurrentStep(e) {
  if (e.target.dataset.step) {
    let shiftX = stepImgAreaWidth * e.target.dataset.step;
    console.log("Слайд: " + e.target.dataset.step + ", смещение: " + shiftX);
    stepImgs.forEach(function(item, i, arr) {
      item.style.transform = "translate3d(-" + shiftX + "px,0,0)";
    });
    stepDescs.forEach(function(item, i, arr) {
      item.style.display = "none";
      if (item.dataset.step == e.target.dataset.step) {
        item.style.display = "block";
      }
    });
    stepBtns.forEach(function(item, i, arr) {
      item.className = "";
    });
    e.target.className = "active";
  }
}

var myMap;

// Дождёмся загрузки API и готовности DOM.
ymaps.ready(init);

function init() {
  var myMap = new ymaps.Map(
      "map",
      {
        center: [55.868864, 37.466844], // Планерная
        zoom: 13,
        behaviors: ["default", "scrollZoom"],
        controls: ["zoomControl"]
      },
      {
        searchControlProvider: "yandex#search"
      }
    ),
    myPlacemark = new ymaps.Placemark(
      [55.868864, 37.466844],

      {
        balloonContentBody:
          "<div class='ballon-point'><div class='ballon-img'><img src='/wp-content/themes/mytheme/img/logo.png'/></div><div class='ballon-content'>Какой-нибудь текст, который откроется при клике на метку карты</div></div>"
      },

      {
        iconLayout: "default#image",
        iconImageHref: "/wp-content/themes/bbs-theme/img/map-marker.png",
        iconImageSize: [66, 90],
        iconImageOffset: [-33, -90]
      }
    );

  myMap.geoObjects.add(myPlacemark);
  myMap.behaviors.disable("scrollZoom");
}
